/* eslint-disable */
import { LocalSourcingVendors } from './LocalSourcingVendors';
import { LocalSourcingFooter } from './LocalSourcingFooter';
import { ShopLocal } from './shoplocal/ShopLocal';
import { CapturedImage } from './CapturedImage';
import React, { useState } from 'react';
import { makeStyles, Typography } from '@rentacenter/racstrap';
import { ReactComponent as InfoIconBlue } from '../../assets/images/info-icon-blue.svg';
import { ShopLocalProvider } from './shoplocal/ShopLocalProvider';
import { NationalPartnerProvider } from './NationalPartnerProvider';
import { EligibilityDecisionData, EligibilityDecisionType } from './EligibilityDecision';
import { useLocation } from 'react-router-dom';


export const useStyles = makeStyles((theme: any) => ({
  pageContainer: {
    padding: '0 1rem 0 1rem',
    height: 'calc(100vh - 205px)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column' as const,
  },
  marketplaceHeader: {
    fontSize: '1.125rem',
    fontWeight: 700,
    marginBottom: '0.75rem',
    marginTop: '0.5rem',
  },
  infoBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    backgroundColor: '#EFF4FF',
    border: '1px solid #B3D4FC',
    borderRadius: '4px',
    padding: '0.875rem 1rem',
    marginBottom: '1rem',
  },
  infoBannerText: {
    fontSize: '0.875rem',
    color: '#111111',
    fontWeight: 500,
  },
  infoIcon: {
    width: '18px',
    height: '18px',
    flexShrink: 0,
    color: '#2468FF',
    fill: '#2468FF',
  },
}));

export const LocalSourcing = () => {
  const classes = useStyles();
  const location = useLocation<any>();
  const [triggerEvaluation, setTriggerEvaluation] = useState<boolean>(false);

  // Get customerId from location state
  const locationState = location.state || {};
  const customerId = locationState.customerId || '';

  const [eligibilityData, setEligibilityData] = useState<EligibilityDecisionData>({
    decision: 'NONE',
    vendorName: '',
    totalCost: '',
  });

  const onConfirmRequest = () => {
    // Triggered after user clicks Confirm Request in Shop Local modal
    setTriggerEvaluation(true);
  };

  const onEvaluationStarted = () => {
    // Reset so it doesn't re-trigger
    setTriggerEvaluation(false);
  };

  const updateEligibilityDecision = (
    decision: EligibilityDecisionType,
    vendorName: string,
    totalCost: string,
    errorMessage?: string,
    classifications?: any
  ) => {
    setEligibilityData({
      decision,
      vendorName,
      totalCost,
      errorMessage,
      classifications,
    });
  };

  return (
    <div className={classes.pageContainer}>
      <div className={classes.infoBanner}>
        <InfoIconBlue className={classes.infoIcon} />
        <Typography className={classes.infoBannerText}>
          {'Please note: You will be required to upload tax-exempt documentation during the checkout process.'}
        </Typography>
      </div>

      <Typography className={classes.marketplaceHeader}>
        {'Local Sourcing Marketplace'}
      </Typography>

      {/* NationalPartnerProvider wraps LocalSourcingVendors + CapturedImage (National Partners flow).
          ShopLocalProvider is specific for Shop Local and must NOT be used with National Partners.
          These two flows are completely separate — data must not be co-mingled. */}
      <NationalPartnerProvider>
        <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <div style={{ height: '40%', display: 'flex', minHeight: 0 }}>
            <div style={{ flex: 1, display: 'flex', minWidth: 0 }}>
              <LocalSourcingVendors />
            </div>
            <div style={{ flex: 1, display: 'flex', minWidth: 0 }}>
              {/* ShopLocalProvider is specific to the Shop Local flow only */}
              <ShopLocalProvider>
                <ShopLocal />
              </ShopLocalProvider>
            </div>
          </div>
          <div style={{ height: '60%', display: 'flex', minHeight: 0 }}>
            <CapturedImage
              triggerEvaluation={triggerEvaluation}
              onEvaluationStarted={onEvaluationStarted}
              eligibilityData={eligibilityData}
              onEligibilityUpdate={updateEligibilityDecision}
            />
          </div>
        </div>

        <LocalSourcingFooter />
      </NationalPartnerProvider>
    </div>
  );
};
